var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.freeBlock.X,
        y: _vm.freeBlock.Y,
        width: _vm.freeBlock.Width,
        height: _vm.freeBlock.Height,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.freeBlock, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.freeBlock, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.freeBlock, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.freeBlock, "Height", $event)
        },
      },
    },
    _vm._l(_vm.freeBlock.Lines, function (line, i) {
      return _c("div", {
        directives: [
          {
            name: "safe-html",
            rawName: "v-safe-html",
            value: _vm.getLineText(line),
            expression: "getLineText(line)",
          },
        ],
        key: i,
        style: line.Style.getStyle(),
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }